import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { assert } from "./errors.js";
// @TODO: timeout is completely ignored; start a Promise.any with a reject?
export function getUrl(_x, _x2) {
  return _getUrl.apply(this, arguments);
}
function _getUrl() {
  _getUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(req, _signal) {
    var protocol, signal, controller, init, resp, headers, respBody, body;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          protocol = req.url.split(":")[0].toLowerCase();
          assert(protocol === "http" || protocol === "https", "unsupported protocol ".concat(protocol), "UNSUPPORTED_OPERATION", {
            info: {
              protocol: protocol
            },
            operation: "request"
          });
          assert(protocol === "https" || !req.credentials || req.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
            operation: "request"
          });
          signal = undefined;
          if (_signal) {
            controller = new AbortController();
            signal = controller.signal;
            _signal.addListener(function () {
              controller.abort();
            });
          }
          init = {
            method: req.method,
            headers: new Headers(Array.from(req)),
            body: req.body || undefined,
            signal: signal
          };
          _context.next = 8;
          return fetch(req.url, init);
        case 8:
          resp = _context.sent;
          headers = {};
          resp.headers.forEach(function (value, key) {
            headers[key.toLowerCase()] = value;
          });
          _context.next = 13;
          return resp.arrayBuffer();
        case 13:
          respBody = _context.sent;
          body = respBody == null ? null : new Uint8Array(respBody);
          return _context.abrupt("return", {
            statusCode: resp.status,
            statusMessage: resp.statusText,
            headers: headers,
            body: body
          });
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getUrl.apply(this, arguments);
}